export default __webpack_public_path__ + "static/media/mbg4.17e10a60.png";